import type { ProcessStep } from '../types/content'

export const processSteps: ProcessStep[] = [
  { title: 'Discovery', detail: 'Your load, site constraints and goals. We start with what the site actually needs.' },
  { title: 'System design and options', detail: 'Engineers configure the system and show you the options side by side.' },
  { title: 'Proposal and documentation pack', detail: 'A clear proposal plus supporting documents in a tender-ready format.' },
  { title: 'Deployment and commissioning', detail: 'Delivery, setup and commissioning on site, with your team briefed on operation.' },
  { title: 'Support and optimisation', detail: 'Ongoing support to keep the system performing as your site changes.' },
]

export const proposalChecklist = [
  'Site location and access details',
  'Load profile, power bills or fuel records',
  'Existing generation (generator size, any solar)',
  'Your goal: diesel displacement, backup or grid support',
  'Timeframe and any tender requirements',
]

export const nextSteps = [
  { title: 'Discovery call', detail: 'An engineer contacts you within 48 hours.' },
  { title: 'Solution design', detail: 'We configure options around your site.' },
  { title: 'Deployment plan', detail: 'Timeline, logistics and commissioning, in writing.' },
]
